import { render } from "./ManageMeasurements.vue?vue&type=template&id=53ab4e44"
import script from "./ManageMeasurements.vue?vue&type=script&lang=js"
export * from "./ManageMeasurements.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__